export const sidePanelData = {
  creditNoteViewPanel: {
    entity: 'creditNote',
    position: "right",
    width: "500px",
    // As invoiceEditPanel.
    defaultSize: "40%",
    maxSize: "900px",
    sections: [
      {
        id: "creditNotePDF",
        meta: {
          type: "pdf",
          width: "600px",
        }
      },
      {
        id: "creditNoteDesign",
        meta: {
          type: "form",
          width: "100%",
        },
        groups: [
          {
            type: "modal",
            id: 'invoiceDesign',
            control: {
              type: "text",
              id: "designModal",
              label: "invoice.form.design",
              placeholder: "invoice.form.design.placeholder"
            },
            descriptions: [
              { type: "label", text: "invoice.form.font.short" },
              { type: "text", text: " " },
              { type: "field", field: "font" },
              { type: "text", text: " - " },
              { type: "label", text: "invoice.form.layout.short" },
              { type: "field", field: "layoutName" },
            ],
            modalFormRef: 'invoiceDesign'
          },
        ],
        buttons: [],
        displaySection: {
          emptyField: "font",
          emptyMessage: "invoice.form.design.missing.message",
          columns: [
            {
              weight: 1,
              basis: "100%",
              elements: [
                { type: "text", value: "invoice.form.design", scale: "title" },
              ],
            },
          ]
        },
      },
    ],
  },
  documentFilePanel: {
    entity: 'document',
    position: 'right',
    width: '500px',
    sections: [
      { id: 'documentPreview', meta: { type: 'documentPreview' } }
    ]
  },
  documentRichTextPanel: {
    entity: 'document',
    position: 'right',
    width: '500px',
    sections: [
      { id: 'documentContent', meta: { type: 'richtextEditor', field: 'content' } }
    ]
  },
  // Mirrors the invoice: the document sits on the left, the entry form on the
  // right. The same panel serves a draft and a booked expense — the navigator
  // itself knows a booked one takes an upload straight to the server.
  expensePanel: {
    entity: 'expense',
    position: "left",
    width: "600px",
    // The receipt's share as it opens; on a wide screen it grows to a page.
    defaultSize: "40%",
    maxSize: "900px",
    // On the left the panel meets the page edge; this is the gap the main
    // view keeps there.
    padding: "1rem 0.5rem 1rem 1rem",
    sections: [
      {
        id: "expenseDocuments",
        meta: {
          type: "documentNavigator",
          generated: { condition: { field: 'source', operator: 'equals', value: 'purchaseOrder' } },
          folder: 'expenses',
          accept: '.pdf,.png,.jpg,.jpeg,.gif,.webp',
          // Expense documents are receipts and invoices: OCR them on upload,
          // then read them into a suggested expense (task 38.03).
          ocr: true,
          extract: 'expense'
        }
      }
    ],
  },
  invoiceEditPanel: {
    entity: 'invoice',
    position: "right",
    width: "500px",
    // The PDF's share as it opens; on a wide screen it grows to an A4 page.
    defaultSize: "40%",
    maxSize: "900px",
    sections: [
      {
        id: "invoicePDF",
        meta: {
          type: "pdf",
          width: "600px",
        }
      },
      {
        id: "invoiceOptions",
        meta: {
          type: "form",
          width: "100%",
        },
        groups: [
          {
            type: "modal",
            id: 'invoiceOptions',
            control: {
              type: "text",
              id: "optionsModal",
              label: "invoice.form.options",
              placeholder: "invoice.form.options.placeholder"
            },
            descriptions: [
              {
                type: "label",
                text: "invoice.form.currency.short",
              },
              {
                type: "text",
                text: " ",
              },
              {
                type: "field",
                field: "currency",
              },
              {
                type: "text",
                text: " - ",
              },
              {
                type: "label",
                text: "invoice.form.language.short",
              },
              {
                type: "text",
                text: " ",
              },
              {
                type: "field",
                field: "language",
              },

            ],
            modalFormRef: 'invoiceOptions'
          },
        ],
        buttons: [],
        displaySection: {
          emptyField: "currency",
          emptyMessage: "invoice.form.design.missing.message",
          columns: [
            {
              weight: 1,
              basis: "100%",
              elements: [
                {
                  type: "text",
                  value: "invoice.form.options",
                  scale: "title"
                },
              ],
            },
          ]
        },
      },
      {
        id: "invoiceDesign",
        meta: {
          type: "form",
          width: "100%",
        },
        groups: [
          {
            type: "modal",
            id: 'invoiceDesign',
            label: 'invoice.form.design.modal.label',
            control: {
              type: "text",
              id: "designModal",
              label: "invoice.form.design",
              placeholder: "invoice.form.design.placeholder"
            },
            descriptions: [
              {
                type: "label",
                text: "invoice.form.font.short",
              },
              {
                type: "text",
                text: " ",
              },
              {
                type: "field",
                field: "font",
              },
              {
                type: "text",
                text: " - ",
              },
              {
                type: "label",
                text: "invoice.form.layout.short",
              },
              {
                type: "field",
                field: "layoutName",
              },
            ],
            modalFormRef: 'invoiceDesign'
          },
        ],
        buttons: [],
        displaySection: {
          emptyField: "font",
          emptyMessage: "invoice.form.design.missing.message",
          columns: [
            {
              weight: 1,
              basis: "100%",
              elements: [
                {
                  type: "text",
                  value: "invoice.form.design",
                  scale: "title"
                },
              ],
            },
          ]
        },
      },
      {
        id: "invoicePayments",
        meta: {
          type: "modalSection",
          width: "100%",
        },
        groups: [
          {
            type: "modal",
            id: 'invoicePayments',
            label: 'invoice.form.payments.modal.label',
            control: {
              type: "text",
              id: "paymentModal",
              label: "invoice.form.payment",
              placeholder: "invoice.form.payment.placeholder"
            },
            descriptions: [
              {
                type: "label",
                text: 'invoice.form.payments.label',
              },
              {
                type: "text",
                text: " ",
              },
              {
                type: "field",
                field: "numPayments",
              }
            ],
            modalFormRef: 'invoicePayments'
          },
        ],
        buttons: [],
        displaySection: {
          emptyField: "payments",
          emptyMessage: "invoice.form.payments.missing.message",
          columns: [
            {
              weight: 1,
              basis: "100%",
              elements: [
                {
                  type: "text",
                  value: "invoice.form.payment",
                  scale: "title",
                  tag: "numPayments"
                },
              ],
            },
          ]
        },
      },
    ],
  },
  invoiceViewPanel: {
    entity: 'invoice',
    position: "right",
    width: "500px",
    // As invoiceEditPanel.
    defaultSize: "40%",
    maxSize: "900px",
    sections: [
      {
        id: "invoicePDF",
        meta: {
          type: "pdf",
          width: "600px",
        }
      },
      {
        id: "invoiceDesign",
        meta: {
          type: "form",
          width: "100%",
        },
        groups: [
          {
            type: "modal",
            id: 'invoiceDesign',
            control: {
              type: "text",
              id: "designModal",
              label: "invoice.form.design",
              placeholder: "invoice.form.design.placeholder"
            },
            descriptions: [
              { type: "label", text: "invoice.form.font.short" },
              { type: "text", text: " " },
              { type: "field", field: "font" },
              { type: "text", text: " - " },
              { type: "label", text: "invoice.form.layout.short" },
              { type: "field", field: "layoutName" },
            ],
            modalFormRef: 'invoiceDesign'
          },
        ],
        buttons: [],
        displaySection: {
          emptyField: "font",
          emptyMessage: "invoice.form.design.missing.message",
          columns: [
            {
              weight: 1,
              basis: "100%",
              elements: [
                { type: "text", value: "invoice.form.design", scale: "title" },
              ],
            },
          ]
        },
      },
    ],
  },
  /*
   * The documents of the journal line in hand — the grid's cursor row, the
   * card's opened line, or the line whose paper clip was clicked. One panel for
   * the journal card, the Fast Journal and a posted journal alike.
   */
  journalPanel: {
    entity: 'journal',
    position: "right",
    width: "500px",
    // The lines are the work; the documents beside them start narrow and
    // can be dragged wider.
    defaultSize: "30%",
    // A page of A4 reads well at this width; wider only spreads it out.
    maxSize: "900px",
    // Folds to a strip with the line's document count, for room to enter
    // lines; dragged narrower than 280px it folds by itself.
    collapsible: true,
    sections: [
      {
        id: "journalLineDocuments",
        meta: {
          type: "lineDocuments",
          lineDocuments: 'journalLine'
        }
      }
    ],
  },
  purchaseOrderEditPanel: {
    entity: 'purchaseOrder',
    position: "right",
    width: "500px",
    // As invoiceEditPanel.
    defaultSize: "40%",
    maxSize: "900px",
    sections: [
      { id: "purchaseOrderPDF", meta: { type: "pdf", width: "600px" } },
      {
        id: "purchaseOrderOptions",
        meta: {
          type: "form",
          width: "100%",
        },
        groups: [
          {
            type: "modal",
            id: 'purchaseOrderOptions',
            control: {
              type: "text",
              id: "optionsModal",
              label: "purchases.purchaseOrder.form.options",
              placeholder: "purchases.purchaseOrder.form.options.placeholder"
            },
            descriptions: [
              { type: "label", text: "purchases.purchaseOrder.form.currency.short" },
              { type: "text", text: " " },
              { type: "field", field: "currency" },
              { type: "text", text: " - " },
              { type: "label", text: "purchases.purchaseOrder.form.language.short" },
              { type: "text", text: " " },
              { type: "field", field: "language" },
            ],
            modalFormRef: 'purchaseOrderOptions'
          },
        ],
        buttons: [],
        displaySection: {
          emptyField: "currency",
          emptyMessage: "purchases.purchaseOrder.form.options.missing.message",
          columns: [
            {
              weight: 1,
              basis: "100%",
              elements: [
                { type: "text", value: "purchases.purchaseOrder.form.options", scale: "title" },
              ],
            },
          ]
        },
      },
      {
        id: "purchaseOrderDesign",
        meta: {
          type: "form",
          width: "100%",
        },
        groups: [
          {
            type: "modal",
            id: 'purchaseOrderDesign',
            control: {
              type: "text",
              id: "designModal",
              label: "purchases.purchaseOrder.form.design",
              placeholder: "purchases.purchaseOrder.form.design.placeholder"
            },
            descriptions: [
              { type: "label", text: "purchases.purchaseOrder.form.font.short" },
              { type: "text", text: " " },
              { type: "field", field: "font" },
              { type: "text", text: " - " },
              { type: "label", text: "purchases.purchaseOrder.form.layout.short" },
              { type: "field", field: "layoutName" },
            ],
            modalFormRef: 'purchaseOrderDesign'
          },
        ],
        buttons: [],
        displaySection: {
          emptyField: "font",
          emptyMessage: "purchases.purchaseOrder.form.design.missing.message",
          columns: [
            {
              weight: 1,
              basis: "100%",
              elements: [
                { type: "text", value: "purchases.purchaseOrder.form.design", scale: "title" },
              ],
            },
          ]
        },
      },
    ],
  },
  purchaseOrderViewPanel: {
    entity: 'purchaseOrder',
    position: "right",
    width: "500px",
    // As invoiceEditPanel.
    defaultSize: "40%",
    maxSize: "900px",
    sections: [
      { id: "purchaseOrderPDF", meta: { type: "pdf", width: "600px" } },
      {
        id: "purchaseOrderDesign",
        meta: {
          type: "form",
          width: "100%",
        },
        groups: [
          {
            type: "modal",
            id: 'purchaseOrderDesign',
            control: {
              type: "text",
              id: "designModal",
              label: "purchases.purchaseOrder.form.design",
              placeholder: "purchases.purchaseOrder.form.design.placeholder"
            },
            descriptions: [
              { type: "label", text: "purchases.purchaseOrder.form.font.short" },
              { type: "text", text: " " },
              { type: "field", field: "font" },
              { type: "text", text: " - " },
              { type: "label", text: "purchases.purchaseOrder.form.layout.short" },
              { type: "field", field: "layoutName" },
            ],
            modalFormRef: 'purchaseOrderDesign'
          },
        ],
        buttons: [],
        displaySection: {
          emptyField: "font",
          emptyMessage: "purchases.purchaseOrder.form.design.missing.message",
          columns: [
            {
              weight: 1,
              basis: "100%",
              elements: [
                { type: "text", value: "purchases.purchaseOrder.form.design", scale: "title" },
              ],
            },
          ]
        },
      },
    ],
  },
  quoteEditPanel: {
    entity: 'quote',
    position: "right",
    width: "500px",
    // As invoiceEditPanel.
    defaultSize: "40%",
    maxSize: "900px",
    sections: [
      {
        id: "quotePDF",
        meta: {
          type: "pdf",
          width: "600px",
        }
      },
      {
        id: "quoteOptions",
        meta: {
          type: "form",
          width: "100%",
        },
        groups: [
          {
            type: "modal",
            id: 'quoteOptions',
            control: {
              type: "text",
              id: "optionsModal",
              label: "quote.form.options",
              placeholder: "quote.form.options.placeholder"
            },
            descriptions: [
              {
                type: "label",
                text: "quote.form.currency.short",
              },
              {
                type: "text",
                text: " ",
              },
              {
                type: "field",
                field: "currency",
              },
              {
                type: "text",
                text: " - ",
              },
              {
                type: "label",
                text: "quote.form.language.short",
              },
              {
                type: "text",
                text: " ",
              },
              {
                type: "field",
                field: "language",
              },
            ],
            modalFormRef: 'quoteOptions'
          },
        ],
        buttons: [],
        displaySection: {
          emptyField: "currency",
          emptyMessage: "quote.form.design.missing.message",
          columns: [
            {
              weight: 1,
              basis: "100%",
              elements: [
                {
                  type: "text",
                  value: "quote.form.options",
                  scale: "title"
                },
              ],
            },
          ]
        },
      },
      {
        id: "quoteDesign",
        meta: {
          type: "form",
          width: "100%",
        },
        groups: [
          {
            type: "modal",
            id: 'quoteDesign',
            control: {
              type: "text",
              id: "designModal",
              label: "quote.form.design",
              placeholder: "quote.form.design.placeholder"
            },
            descriptions: [
              {
                type: "label",
                text: "quote.form.font.short",
              },
              {
                type: "text",
                text: " ",
              },
              {
                type: "field",
                field: "font",
              },
              {
                type: "text",
                text: " - ",
              },
              {
                type: "label",
                text: "quote.form.layout.short",
              },
              {
                type: "field",
                field: "layoutName",
              },
            ],
            modalFormRef: 'quoteDesign'
          },
        ],
        buttons: [],
        displaySection: {
          emptyField: "font",
          emptyMessage: "quote.form.design.missing.message",
          columns: [
            {
              weight: 1,
              basis: "100%",
              elements: [
                {
                  type: "text",
                  value: "quote.form.design",
                  scale: "title"
                },
              ],
            },
          ]
        },
      }
    ],
  },
  quoteViewPanel: {
    entity: 'quote',
    position: "right",
    width: "500px",
    // As invoiceEditPanel.
    defaultSize: "40%",
    maxSize: "900px",
    sections: [
      {
        id: "quotePDF",
        meta: {
          type: "pdf",
          width: "600px",
        }
      },
      {
        id: "quoteDesign",
        meta: {
          type: "form",
          width: "100%",
        },
        groups: [
          {
            type: "modal",
            id: 'quoteDesign',
            control: {
              type: "text",
              id: "designModal",
              label: "quote.form.design",
              placeholder: "quote.form.design.placeholder"
            },
            descriptions: [
              { type: "label", text: "quote.form.font.short" },
              { type: "text", text: " " },
              { type: "field", field: "font" },
              { type: "text", text: " - " },
              { type: "label", text: "quote.form.layout.short" },
              { type: "field", field: "layoutName" },
            ],
            modalFormRef: 'quoteDesign'
          },
        ],
        buttons: [],
        displaySection: {
          emptyField: "font",
          emptyMessage: "quote.form.design.missing.message",
          columns: [
            {
              weight: 1,
              basis: "100%",
              elements: [
                { type: "text", value: "quote.form.design", scale: "title" },
              ],
            },
          ]
        },
      },
    ],
  },
  stockReceiptEditPanel: {
    entity: 'stockReceipt',
    position: "right",
    width: "500px",
    // As invoiceEditPanel.
    defaultSize: "40%",
    maxSize: "900px",
    sections: [
      {
        id: "stockReceiptPDF",
        meta: {
          type: "pdf",
          width: "600px",
        }
      }
    ],
  },
  stockReceiptViewPanel: {
    entity: 'stockReceipt',
    position: "right",
    width: "500px",
    // As invoiceEditPanel.
    defaultSize: "40%",
    maxSize: "900px",
    sections: [
      {
        id: "stockReceiptPDF",
        meta: {
          type: "pdf",
          width: "600px",
        }
      },
      {
        id: "stockReceiptDesign",
        meta: {
          type: "form",
          width: "100%",
        },
        groups: [
          {
            type: "modal",
            id: 'inventoryShipmentDesign',
            control: {
              type: "text",
              id: "designModal",
              label: "inventory.shipment.form.design",
              placeholder: "inventory.shipment.form.design.placeholder"
            },
            descriptions: [
              { type: "label", text: "inventory.shipment.form.font.short" },
              { type: "text", text: " " },
              { type: "field", field: "font" },
              { type: "text", text: " - " },
              { type: "label", text: "inventory.shipment.form.layout.short" },
              { type: "field", field: "layoutName" },
            ],
            modalFormRef: 'inventoryShipmentDesign'
          },
        ],
        buttons: [],
        displaySection: {
          emptyField: "font",
          emptyMessage: "inventory.shipment.form.font.missing.message",
          columns: [
            {
              weight: 1,
              basis: "100%",
              elements: [
                { type: "text", value: "inventory.shipment.form.font.edit.label", scale: "title" },
              ],
            },
          ]
        },
      },
    ],
  },
  stockShipmentEditPanel: {
    entity: 'stockShipment',
    position: "right",
    width: "500px",
    // As invoiceEditPanel.
    defaultSize: "40%",
    maxSize: "900px",
    sections: [
      {
        id: "stockShipmentPDF",
        meta: {
          type: "pdf",
          width: "600px",
        }
      },
      {
        id: "stockShipmentDesign",
        meta: {
          type: "form",
          width: "100%",
        },
        groups: [
          {
            type: "modal",
            id: 'inventoryShipmentDesign',
            label: 'invoice.form.design.modal.label',
            control: {
              type: "text",
              id: "designModal",
              label: "inventory.shipment.form.design",
              placeholder: "inventory.shipment.form.design.placeholder"
            },
            descriptions: [
              {
                type: "label",
                text: "inventory.shipment.form.font.short",
              },
              {
                type: "text",
                text: " ",
              },
              {
                type: "field",
                field: "font",
              },
              {
                type: "text",
                text: " - ",
              },
              {
                type: "label",
                text: "inventory.shipment.form.layout.short",
              },
              {
                type: "field",
                field: "layoutName",
              },
            ],
            modalFormRef: 'inventoryShipmentDesign'
          },
        ],
        buttons: [],
        displaySection: {
          emptyField: "font",
          emptyMessage: "inventory.shipment.form.font.missing.message",
          columns: [
            {
              weight: 1,
              basis: "100%",
              elements: [
                {
                  type: "text",
                  value: "inventory.shipment.form.font.edit.label",
                  scale: "title"
                },
              ],
            },
          ]
        },
      },
      {
        id: "inventory.shipment.reservation",
        meta: {
          type: "modalSection",
          condition: { field: '$mode', operator: 'equals', value: 'edit' },
          width: "100%",
          modalPadding: "0rem 1rem 1rem"
        },
        groups: [
          {
            type: "modal",
            id: 'inventoryShipmentReservations',
            label: 'inventory.shipment.form.reservations.modal.label',
            control: {
              type: "text",
              id: "reservationsModal",
              label: "inventory.shipment.form.reservations",
              placeholder: "inventory.shipment.form.reservations.placeholder"
            },
            descriptions: [
              {
                type: "label",
                text: 'inventory.shipment.form.reservations.label',
              },
              {
                type: "text",
                text: " ",
              },
              {
                type: "field",
                field: "totalReservations",
              }
            ],
            modalFormRef: 'inventoryShipmentReservations'
          },
        ],
        buttons: [],
        displaySection: {
          emptyField: "totalReservedProducts",
          emptyMessage: "inventory.shipment.form.reservations.missing.message",
          columns: [
            {
              weight: 1,
              basis: "100%",
              elements: [
                {
                  type: "text",
                  value: "inventory.shipment.form.reservations",
                  scale: "title",
                  tag: "totalReservedProducts"
                },
              ],
            },
          ]
        },
      },
    ],
  },
  stockShipmentViewPanel: {
    entity: 'stockShipment',
    position: "right",
    width: "500px",
    // As invoiceEditPanel.
    defaultSize: "40%",
    maxSize: "900px",
    sections: [
      {
        id: "stockShipmentPDF",
        meta: {
          type: "pdf",
          width: "600px",
        }
      },
      {
        id: "stockShipmentDesign",
        meta: {
          type: "form",
          width: "100%",
        },
        groups: [
          {
            type: "modal",
            id: 'inventoryShipmentDesign',
            control: {
              type: "text",
              id: "designModal",
              label: "inventory.shipment.form.design",
              placeholder: "inventory.shipment.form.design.placeholder"
            },
            descriptions: [
              { type: "label", text: "inventory.shipment.form.font.short" },
              { type: "text", text: " " },
              { type: "field", field: "font" },
              { type: "text", text: " - " },
              { type: "label", text: "inventory.shipment.form.layout.short" },
              { type: "field", field: "layoutName" },
            ],
            modalFormRef: 'inventoryShipmentDesign'
          },
        ],
        buttons: [],
        displaySection: {
          emptyField: "font",
          emptyMessage: "inventory.shipment.form.font.missing.message",
          columns: [
            {
              weight: 1,
              basis: "100%",
              elements: [
                { type: "text", value: "inventory.shipment.form.font.edit.label", scale: "title" },
              ],
            },
          ]
        },
      },
    ],
  },
  warehouseOrderEditPanel: {
    entity: 'warehouseOrder',
    position: 'right',
    width: '400px',
    sections: [
      {
        id: 'warehouseOrderInfo',
        meta: { type: 'infoPanel' },
        groups: [
          { type: 'text-readOnly', id: 'sourceDocumentNumber', label: 'warehouseOrder.form.sourceDocument' },
          { type: 'text-readOnly', id: 'assignedToName', label: 'warehouseOrder.form.assignedTo' }
        ]
      }
    ]
  },
  warehouseOrderViewPanel: {
    entity: 'warehouseOrder',
    position: 'right',
    width: '400px',
    sections: [
      {
        id: 'warehouseOrderViewInfo',
        meta: { type: 'infoPanel' },
        groups: [
          { type: 'text-readOnly', id: 'typeName', label: 'warehouseOrder.form.type' },
          { type: 'text-readOnly', id: 'sourceDocumentNumber', label: 'warehouseOrder.form.sourceDocument' },
          { type: 'text-readOnly', id: 'assignedToName', label: 'warehouseOrder.form.assignedTo' }
        ]
      }
    ]
  },
};
